export default "__VITE_ASSET__CDjQj44$__"